export const ESTADOS = [
    'PENDIENTE',
    'ASIGNADO',
    'PROCESO',
    'REVISAR',
    'FINALIZADO',
    'CERRADO',
]
